/**
 * @author Harshitha.k
 * @description 
 */

import '.././style.css';
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import Editor from '@monaco-editor/react';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { DrawerFooter } from '../../../commons/styles/layout';
import { API_MASTERCONFIGURATION, REPORTS } from '../../../commons/api';
import ReportTypeComponent from '../ReportTypeConfiguration/ReportTypeComponent';
import { CaretRightOutlined, EnterOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Drawer,
  Button,
  Collapse,
  Popover,
  Input,
  Row,
  Col,
  Select,
  message,
  Form,
  Segmented
} from 'antd';

const { Option } = Select;
const { Panel } = Collapse;

const customPanel = {
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden'
};

const ReportConfiguration = (props) => {
  const [visible, setVisible] = useState(false);
  // const [manocoEditorValue, setManocoEditorValue] = useState('');
  const [editList, setEditList] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [tabName, setTabName] = useState('');
  const [datasource, setDatasource] = useState([]);
  const [editObj, setEditObj] = useState({});
  const [reportTypeList, setReportTypeList] = useState([]);
  // const [type, setType] = useState('');
  const [userProfile, setUserProfile] = useState(props.userProfile);
  const [userId, setUserId] = useState(props.userDeatils);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [saveReportData, setSaveReportData] = useState(false);
  const [editType, setEditType] = useState('Form');
  const [initialState, setInitialState] = useState({});
  const [editEditor, setEditEditor] = useState({});
  const [searchText, setSearchText] = useState('');
  const [editID,setEditID] = useState('');
  const reportConfig = useRef();
  const editorRef = useRef();
  const [query,setQuery] = useState('');
  const [showHideTextArea,setShowHideTextArea] = useState(false);

  useEffect(() => {    
    _getReportList();
    _getReportTypeList();
  }, []);

  useEffect(() => {
    setUserId(props.UserDetails);
  }, [props.UserDetails]);

  useEffect(() => {
    setTranslationCache(props.translationCache);
    setUserProfile(props.userProfile);
  }, [props.translationCache, props.language, props.userProfile]);

  const _getReportList = () => {
    const siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    const healthHeaders = {
      method: 'GET',
      url: `${REPORTS.Get}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(healthHeaders)
      .then((response) => {
        if (Array.isArray(response.data)) {
          setDatasource(response.data);
        }
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  const _getReportTypeList = () => {
    const siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    const healthHeaders = {
      method: 'POST',
      url: `${API_MASTERCONFIGURATION.Master}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { MasterCode: 'Report_Types', ActionType: 'read', Type: 'WithoutSiteId' }
    };
    axios(healthHeaders)
      .then((response) => {
        if (Array.isArray(response.data)) {
          setReportTypeList(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onClose = () => {
    setQuery('');
    setShowHideTextArea(showHideTextArea);
    if (reportConfig.current) {
      reportConfig.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
  };

 const onTabNameInput = (e) => {
    setTabName(e.target.value);
  };

  const addNewTab = () => {
    let newObj = {
      TabName: tabName,
      JSON: {},
      type: 'save'
    };
    setQuery('');
    setShowHideTextArea(showHideTextArea);
    setEditList((prevEditList) => [...prevEditList, newObj]);
    setClicked(false);
  };

  const handleClickChange = (visible) => {
    setClicked(visible);
  };

  // const hide = () => {
  //   setClicked(false);
  // };

  const addNewReport = () => {
    let initialObj = {};
    
    if (reportConfig.current) {
      reportConfig.current.setFieldsValue({
        ReportName: '',
        ReportType: ''
      });
      
      initialObj = {
        ReportName: '',
        ReportType: ''
      };
    }

    setQuery('');
    setShowHideTextArea(false);
    setEditEditor({});
    setVisible(true);
    setEditObj({});
    setInitialState(initialObj);
    setEditList([]);
    setSaveReportData(false);
  };

  const saveReport = (object, operation, userId) => {
    let editEditorValue = editorRef.current && editorRef.current.getValue();
    if (operation === 'delete') {
      reportConfig.current
        .validateFields()
        .then(async () => {
          _deleteReportAPI(editID);
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (operation === 'save') {
      reportConfig.current && reportConfig.current
        .validateFields()
        .then(async (values) => {
          try {
            if (editType === 'Json-editor') {
              let newObj = {
                JSON: typeof editEditorValue === 'string'
                ? editEditorValue
                : {},
                TabName: object.TabName,
                ReportType: values.ReportType,
                ReportName: values.ReportName,
                CreatedBy: userId.Id
              };

              if (query && query !== '') {
                newObj.JSON.api.query = query;
              }
              _saveReportAPI(newObj);
            } else if (editType === 'Form') {
              let newObj = {
                JSON: editObj,
                TabName: object.TabName,
                ReportType: values.ReportType,
                ReportName: values.ReportName,
                CreatedBy: userId.Id
              };

              if (query && query !== '') {
                newObj.JSON.api.query = query;
              }
              _saveReportAPI(newObj);
            }
          } catch (error) {
            message.error('Invalid JSON format. Please check your input.');
            console.error('JSON parsing error:', error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (operation === 'update') {
      reportConfig.current
        .validateFields()
        .then(async () => {
          try {
            if (editType === 'Json-editor') {
              // const parsedJSON = JSON.parse(editEditorValue) || {} ;
              let newObj = {
                JSON: typeof editEditorValue === 'string'
                ? editEditorValue
                : {},
                TabName: object.TabName,
                ReportType: editList[0].ReportType,
                ReportName: editList[0].ReportName,
                CreatedBy: userId.Id,
                Id: editID
              };
              if (query && query !== '') {
                newObj.JSON.api.query = query;
              }
              _updateReportAPI(newObj);
            } else if (editType === 'Form') {
              let newObj = {
                JSON: editObj,
                TabName: object.TabName,
                ReportType: editList[0].ReportType,
                ReportName: editList[0].ReportName,
                CreatedBy: userId.Id,
                Id: editID
              };
              if (query && query !== '') {
                newObj.JSON.api.query = query;
              }
              _updateReportAPI(newObj);
            }
          } catch (error) {
            message.error('Invalid JSON format. Please check your input.');
            console.error('JSON parsing error:', error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const saveData = (editObj) => {
    setEditObj({ ...editObj });
  };

  const _saveReportAPI = (payload) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const deviceTypeObject = {
      method: 'POST',
      url: `${REPORTS.CREATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { ...payload, SiteId: siteId }
    };
    axios(deviceTypeObject)
      .then(() => {
        setVisible(false);
        if (reportConfig.current) {
          reportConfig.current.resetFields();
        }
        _getReportList();
        setQuery('');
        setShowHideTextArea(showHideTextArea);
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  const _updateReportAPI = (payload) => {
    const siteId = localStorage.get('currentSite');
 const accessToken = localStorage.get('accessToken');
    const deviceTypeObject = {
      method: 'PATCH',
      url: `${REPORTS.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { ...payload, SiteId: siteId }
    };
    axios(deviceTypeObject)
      .then(() => {
        setVisible(false);
        if (reportConfig.current) {
          reportConfig.current.resetFields();
        }
        _getReportList();
        setQuery('');
        setShowHideTextArea(showHideTextArea);
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  const _getReportJsonList = (payload) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const deviceTypeObject = {
      method: 'GET',
      url: `${REPORTS.Get}?SiteId=${siteId}&ReportName=${payload.ReportName}&ReportType=${payload.ReportType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(deviceTypeObject)
      .then((response) => {
        let editListData = response.data.map((edit) => {
          return {
            ...edit,
            editEditor: edit.JSON
          };
        });
        setEditList(editListData);
      })
      .catch(() => {});
  };

  const _deleteReportAPI = (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const deviceTypeObject = {
      method: 'DELETE',
      url: `${REPORTS.Delete}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(deviceTypeObject)
      .then(() => {
        setVisible(false);
        _getReportList();
      })
      .catch((err) => {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  // const editorDidMount = (editor) => {
  //   console.log();
  //   setTimeout(() => {
  //     editor.getAction('editor.action.formatDocument').run();
  //   }, 300);
  // };

  // const editorWillMount = (monaco) => {
  //   monaco.languages.typescript.typescriptDefaults.setCompilerOptions({});
  // };

  // const addQuery = (e) => {
  //   query = e.target.value;
  // };

  // const textArea = () => {
  //   showHideTextArea = !showHideTextArea;
  //   setShowHideTextArea(showHideTextArea);
  // };

  // const handleImport = (e) => {
  //   const reader = new FileReader();
  //   reader.readAsText(e[0]);
  //   reader.onloadend = function () {
  //     let fileData = JSON.parse(reader.result);
  //     delete fileData.editObj.ReportName;
  //     fileData.editList.forEach((list) => {
  //       list.type = 'save';
  //     });
  //     setEditList(fileData.editList);
  //     setEditObj(fileData.editObj);
  //   };
  // };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8, color: 'white !important' }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)}  style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout (() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const onFinishFailed = () => {
    message.error('please enter required fields');
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const columns = [
    {
      title: translation('Report Name'),
      dataIndex: 'ReportName',
      key: 'ReportName',
      ...getColumnSearchProps('ReportName'),
      width: '60%',
      render: (text, record) => (
        <Link
          to={{ pathname: `/rubus/report/${record.ReportType}/${record.ReportName}` }}
        >
          {text}
        </Link>
      )
    },
    {
      title: translation('Report Type'),
      dataIndex: 'ReportType',
      key: 'ReportType',
      ...getColumnSearchProps('ReportType')
    }
  ];

  const siteId = localStorage.get('currentSite');

  const permissionsArray = userProfile?.belongsTo?.sites?.[siteId]?.role?.Permission
    .filter((item) => item.resource === 'reports')
    .map((name) => name.action) || [];


  return (
    <>
      <Drawer
        title={translation('Configuration')}
        placement="right"
        width={1500}
        onClose={onClose}
        open={visible}
        closable
      >
        <Form
          layout="vertical"
          ref={reportConfig}
          name="Site_form"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 24 }}
          initialValues={initialState || {}}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col   span={18}>
              <Form.Item
                label={translation('Report Name :')}
                name="ReportName"
                shouldUpdate={(prevValues, curValues) =>
                  prevValues.ReportName !== curValues.ReportName ||
                  prevValues.ReportType !== curValues.ReportType
                }
              >
                <Input
                  placeholder={translation('Please enter Report Name')}
                  disabled={!initialState.ReportName ? false : true}
                />
              </Form.Item>
              <Form.Item label={translation('Report Type :')} name="ReportType">
                <Select
                  placeholder={translation('Please select Report Type')}
                  disabled={!initialState.ReportType ? false : true}
                >
                  {reportTypeList.map((reportType, index) => (
                    <Option key={index} value={reportType.ReportType}>
                      {reportType.ReportType}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Popover
          content={
            <div style={{ display: 'flex' }}>
              <Input
                placeholder={translation('Enter TabName')}
                
                onChange={onTabNameInput}
              />
              <EnterOutlined
                style={{
                  marginTop: '1px',
                  marginLeft: '4px',
                  cursor: 'pointer'
                }}
                onClick={addNewTab}
              />
            </div>
          }
          title={translation('Enter TabName')}
          trigger="click"
          open={clicked}
          onOpenChange={handleClickChange}
        >
          <Button type={'primary'}>Add Items</Button>
        </Popover>
        {editList.map((list, key) => (
          <Collapse
            key={key}
            bordered={false}
            style={{ marginTop: '20px' }}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          >
            <Panel header={list.TabName || tabName} style={customPanel}>
              <Segmented
                options={['Form', 'Json-editor']}
                value={editType}
                onChange={setEditType}
              />
              {editType === 'Form' ? (
                <ReportTypeComponent
                  editObj={editObj ? editObj : {}}
                  reportType={editObj.ReportType}
                  reportName={editObj.ReportName}
                  currentTab={list.TabName}
                  reportObject={list.editEditor}
                  list={list}
                  saveReportData={saveReportData}
                  saveData={saveData}
                />
              ) : (
                <Editor
                  ref={editorRef}
                  height="70vh"
                  defaultLanguage="json"
                  theme='vs-dark'
                  defaultValue={JSON.stringify(editEditor, null, '\t')}
                  value={JSON.stringify(list.editEditor, null, '\t')}
                  onMount={(editor) => (editorRef.current = editor)}
                />
              )}
              {list.type === 'save' ? (
                <Button
                  shape="round"
                  className="reportbutton"
                  onClick={() => saveReport(list, 'save', userId)}
                >
                  {translation('Save')}
                </Button>
              ) : (
                <Button
                  shape="round"
                  disabled={!permissionsArray.includes('update') ? true : false}
                  onClick={() => saveReport(list, 'update', userId)}
                  className="reportbutton"
                >
                  {translation('Update')}
                </Button>
              )}
              <Button
                shape="round"
                disabled={!permissionsArray.includes('delete') ? true : false}
                onClick={() => saveReport(list, 'delete', userId)}
                className="reportbutton"
                style={{ marginLeft: '5px' }}
              >
                {translation('Delete')}
              </Button>
            </Panel>
          </Collapse>
        ))}
        <DrawerFooter>
          <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
        </DrawerFooter>
      </Drawer>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <Button type='primary' onClick={addNewReport} style={{ color: 'white !important' }}>
          <PlusOutlined />
          {translation('New Report')}
        </Button>
      </div>
      <StyledTable size="small"
        columns={columns}
        dataSource={datasource.map((data, index) => ({ ...data, key: index }))}
        onRow={(record) => ({
          onClick: () => {
            if (reportConfig.current) {
              reportConfig.current.setFieldsValue(record);
            }
            setVisible(true);
            setEditObj(record.JSON);
            setEditID(record.Id);
            setInitialState(record);
            setSaveReportData(true);
            _getReportJsonList(record);
          }
        })}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  UserDetails: state.LayoutReducer.UserDetails,
  translationCache: state.TranslationReducer.translationCache,
});

export default connect(mapStateToProps)(ReportConfiguration);